module.exports = __webpack_public_path__ + "public/img/banner-1.71309ccf.jpg";